import {
  Agent,
  AnyChatMessageBlock,
  ChatMessage,
  ChatMessageArgs,
  ChatMessageBlockType,
  ChatMessageGeneralEventAgentCallBlock,
  ChatMessageGeneralEventAgentTransferBlock,
  ChatMessageGeneralEventBlock,
  ChatMessageGeneralEventType,
  ChatMessageGeneralEventVisitorCallbackAgentBlock,
  ChatMessageGeneralEventVisitorMissedAgentCallBlock,
} from './types';

export function makeChatMessageFromAgent(
  visitorId: string,
  conversationId: number,
  blocks: ChatMessage['content']['blocks'],
): ChatMessageArgs {
  return {
    visitorId,
    conversationId,
    content: {
      blocks,
    },
  };
}

export function makeBlockGeneralEventAgentCall(
  agent: Agent,
): ChatMessageGeneralEventAgentCallBlock {
  return {
    type: ChatMessageBlockType.GENERAL_EVENT,
    generalEventType: ChatMessageGeneralEventType.AGENT_CALL,
    agent,
  };
}

export function makeBlockGeneralEventAgentTransfer(
  agent: Agent,
): ChatMessageGeneralEventAgentTransferBlock {
  return {
    type: ChatMessageBlockType.GENERAL_EVENT,
    generalEventType: ChatMessageGeneralEventType.AGENT_TRANSFER,
    agent,
  };
}

export function makeBlockGeneralEventVisitorMissedAgentCall(
  agent: Agent,
): ChatMessageGeneralEventVisitorMissedAgentCallBlock {
  return {
    type: ChatMessageBlockType.GENERAL_EVENT,
    generalEventType: ChatMessageGeneralEventType.VISITOR_MISSED_AGENT_CALL,
    agent,
  };
}

export function makeBlockGeneralEventVisitorCallbackAgent(
  agent: Agent,
): ChatMessageGeneralEventVisitorCallbackAgentBlock {
  return {
    type: ChatMessageBlockType.GENERAL_EVENT,
    generalEventType: ChatMessageGeneralEventType.VISITOR_CALLBACK_AGENT,
    agent,
  };
}

export function findGeneralEventBlock(message: ChatMessage) {
  const block = message.content.blocks.find(
    b => b.type === ChatMessageBlockType.GENERAL_EVENT,
  );
  if (block && isGeneralEventBlock(block)) {
    return block;
  }
}

export function isGeneralEventBlock(
  block: AnyChatMessageBlock,
): block is ChatMessageGeneralEventBlock {
  return block.type === ChatMessageBlockType.GENERAL_EVENT;
}
